import type { MondayCampaignTemplateDTO, MondayTouchpointTemplateDTO } from "generated/schemas";

const buildTouchpointMap = (
  campaignTemplates: MondayCampaignTemplateDTO[],
): Map<string, MondayTouchpointTemplateDTO> => {
  const map = new Map();
  for (const ct of campaignTemplates) {
    for (const tp of ct.touchpointTemplates ?? []) {
      map.set(tp.id, tp);
    }
  }
  return map;
};

export const getSelectedTemplates = (
  templateIds: Record<string, boolean>,
  campaignTemplates: MondayCampaignTemplateDTO[],
): MondayTouchpointTemplateDTO[] => {
  const touchpointById = buildTouchpointMap(campaignTemplates);

  return Object.entries(templateIds)
    .filter(([, selected]) => selected)
    .map(([id]) => touchpointById.get(id))
    .filter((t): t is MondayTouchpointTemplateDTO => !!t);
};
